import React from 'react';

import CalendarIcon from '~/components/icons/CalendarIcon';
import type { IconProps } from '~/components/icons/types';
import colors from '~/theme/tailwind/colors';

// CalendarIcon paints its paths only with `iconColor`, which the claim page side bar and its ordering screen
// never pass, so default it to the colour SvgIcon gives the other side-bar icons.
const ClaimMilestonesIcon: React.FC<IconProps> = ({ iconColor = colors.slate['900'], ...props }) => (
  <CalendarIcon iconColor={iconColor} {...props} />
);

export default ClaimMilestonesIcon;
